import { UserLabel } from "./user-label";

export class UserLabels {
        
    constructor() {        
    }

    userLabels: UserLabel[];
    count: number;  
}